export default function AnimateBasket($animate, $timeout) {
    'ngInject';
            return function(scope, elem, attr) {
                scope.$watch(attr.animateBasket, function(newValue, oldValue) {
                    if (newValue > oldValue) {
                        const menu = angular.element('#cartMenu');
                        $timeout(function() {
                            menu.click();
                        }, 500);
                    }
                });
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/main/directives/animateBasket.directive.js